(function () {
  'use strict';

  angular.module('app').component('checkInGuestToItem', checkInGuestToItem());

  function checkInGuestToItem() {
    return {
      bindings: {
        item: '<',
        onSavedItem: '&',
        onCanceledItem: '&',
      },
      controller: CheckInGuestToItemComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/bookings/booking-guests/check-in-guest-to-item/check-in-guest-to-item.component.html',
    };
  }

  CheckInGuestToItemComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'moment',
    'GuestService',
    'ModalWindowConfirmService',
  ];

  function CheckInGuestToItemComponent(
    config,
    UtilService,
    moment,
    GuestService,
    ModalWindowConfirmService
  ) {
    const vm = this;

    vm.UtilService = new UtilService(vm);
    vm.dateDisplay = config.DATE_DISPLAY;
    vm.hourDisplay = config.HOUR_DISPLAY;

    let notes = [];
    let modalParams = {
      confirmButtonLabel: 'YES',
      cancelButtonLabel: 'NO',
      preventModalClose: true,
      notes: null,
      body: null,
      title: null,
      showOnlyConfirmButton: null,
    };

    // Methods
    vm.saveAddGuestToBookingItem = saveAddGuestToBookingItem;
    vm.checkAllBookingItems = checkAllBookingItems;
    vm.checkBookingItem = checkInBookingItem;
    vm.cancel = cancel;

    vm.$onInit = function () {
      vm.guest = angular.copy(vm.item.guest);
      vm.guestName = `${vm.guest.name} ${vm.guest.last_name}`;

      selectBookingItems(vm.item.booking.booking_items);
    };

    function selectBookingItems(bookingItems) {
      vm.bookingItems = [];

      bookingItems.forEach((bookingItem) => {
        if (bookingItem.based_on_service_items) {
          bookingItem.booking_item_service_items.forEach((serviceItem) => {
            if (serviceItem.guest_ids.includes(vm.guest.id)) {
              serviceItem.selected = true;

              if (!vm.bookingItems.includes(bookingItem)) vm.bookingItems.push(bookingItem);
            }
          });
        } else {
          if (bookingItem.guest_ids.includes(vm.guest.id)) vm.bookingItems.push(bookingItem);
        }
      });

      checkInItems(vm.bookingItems, vm.guest);
    }

    function checkAllBookingItems() {
      let successCallback = (data) => {
        vm.optionalNotes = data;

        vm.bookingItems.forEach((item) => {
          if (item.based_on_service_items) {
            item.booking_item_service_items.forEach((service_item) => {
              if (service_item.selected && moment().diff(moment(item.start_date), 'days') >= 0) {
                service_item.checkIn = vm.allBookingItemsChecked;
                addNotes(service_item.id, vm.optionalNotes);
              }
            });
          } else {
            if (moment().diff(moment(item.start_date), 'days') >= 0) {
              item.checkIn = vm.allBookingItemsChecked;
              addNotes(item.id, vm.optionalNotes);
            }
          }
        });

        validateCheckedInBookingItems();
        saveAddGuestToBookingItem();
      };

      let cancelCallback = (data) => {
        vm.optionalNotes = data || '';
        vm.allBookingItemsChecked = !vm.allBookingItemsChecked;
      };

      modalParams.notes = 'OPTIONAL_NOTES';
      modalParams.body = vm.allBookingItemsChecked
        ? 'ARE_YOU_SURE_TO_CHECK_IN_ALL_ITEMS_BODY'
        : ' ';
      modalParams.title = vm.allBookingItemsChecked
        ? 'ARE_YOU_SURE_TO_CHECK_IN_ALL_ITEMS'
        : 'ARE_YOU_SURE_TO_CHECK_OUT_ALL_ITEMS';

      ModalWindowConfirmService.open(modalParams, successCallback, cancelCallback);
    }

    function checkInBookingItem(isChecked, bookingItem, bookingItemServiceItem) {
      modalParams.notes = 'OPTIONAL_NOTES';
      modalParams.body = ' ';

      let successCallback = function (data) {
        bookingItem.checkIn = bookingItem.checkIn;
        vm.optionalNotes = data || '';

        addNotes(bookingItem.id, vm.optionalNotes);
        validateCheckedInBookingItems();

        saveAddGuestToBookingItem();
      };

      let cancelCallback = function (data) {
        bookingItem.checkIn = !bookingItem.checkIn;
      };

      if (bookingItemServiceItem && bookingItem.checkIn) {
        checkServiceDate(bookingItemServiceItem, successCallback, cancelCallback);
      } else if (bookingItem.checkIn) {
        checkServiceDate(bookingItem, successCallback, cancelCallback);
      } else {
        modalParams.title = 'ARE_YOU_SURE_TO_CHECK_OUT';

        ModalWindowConfirmService.open(modalParams, successCallback, cancelCallback);
      }
    }

    function checkServiceDate(bookingItem, successCallback, cancelCallback) {
      modalParams.notes = 'OPTIONAL_NOTES';
      modalParams.body = ' ';

      if (moment(bookingItem.start_date) < moment()) {
        modalParams.title = 'SELECTED_BOOKING_ITEMS_PAST';
      } else if (
        moment().diff(moment(bookingItem.start_date), 'days') < 2 &&
        moment().diff(moment(bookingItem.start_date), 'days') >= 0
      ) {
        modalParams.title = 'ARE_YOU_SURE_TO_CHECK_IN';
      } else {
        modalParams.title = 'CHECK_IN_IS_NOT_ALLOW';
        modalParams.confirmButtonLabel = 'ACCEPT';
        modalParams.showOnlyConfirmButton = true;

        delete modalParams.body;
        delete modalParams.notes;

        ModalWindowConfirmService.open(modalParams, cancelCallback);

        return;
      }

      ModalWindowConfirmService.open(modalParams, successCallback, cancelCallback);
    }

    function validateCheckedInBookingItems() {
      let allItemsChecked = true;
      vm.bookingItems.forEach((item) => {
        if (item.based_on_service_items) {
          item.booking_item_service_items.forEach((service_item) => {
            if (service_item.selected && !service_item.checkIn) allItemsChecked = false;
          });
        } else {
          if (!item.checkIn) allItemsChecked = false;
        }
      });

      vm.allBookingItemsChecked = allItemsChecked;

      addCheckedInGuestToBookingItem(vm.bookingItems, vm.guest);
    }

    function addCheckedInGuestToBookingItem(bookingItems, guest) {
      bookingItems.forEach((bookingItem) => {
        if (bookingItem.based_on_service_items) {
          bookingItem.booking_item_service_items.forEach((serviceItem) => {
            let isServiceItemAdded = guest.checked_in_service_items.includes(serviceItem.id);
            if (serviceItem.checkIn && !isServiceItemAdded) {
              // guest.checked_in_service_items = guest.checked_in_service_items || [];
              guest.checked_in_service_items.push(serviceItem.id);
            } else if (!serviceItem.checkIn && isServiceItemAdded) {
              guest.checked_in_service_items.splice(
                guest.checked_in_service_items.map((id) => id).indexOf(serviceItem.id),
                1
              );
            }
          });
        } else {
          let isBookingItemAdded = guest.checked_in_booking_items.includes(bookingItem.id);
          if (bookingItem.checkIn && !isBookingItemAdded) {
            // guest.checked_in_booking_items = guest.checked_in_booking_items || [];
            guest.checked_in_booking_items.push(bookingItem.id);
          } else if (!bookingItem.checkIn && isBookingItemAdded) {
            guest.checked_in_booking_items.splice(
              guest.checked_in_booking_items.map((id) => id).indexOf(bookingItem.id),
              1
            );
          }
        }
      });
    }

    function addNotes(id, note) {
      let index = notes
        .map((item) => {
          return item.id;
        })
        .indexOf(id);

      if (index < 0) {
        notes.push({ id: id, notes: note });
      } else {
        notes[index] = { id: id, notes: note };
      }
    }

    function checkInItems(bookingItems, guest) {
      bookingItems.forEach((bookingItem) => {
        if (bookingItem.based_on_service_items) {
          bookingItem.booking_item_service_items.forEach((serviceItem) => {
            serviceItem.checkIn = guest.checked_in_service_items.includes(serviceItem.id);
          });
        } else {
          bookingItem.checkIn = guest.checked_in_booking_items.includes(bookingItem.id);
        }
      });

      validateCheckedInBookingItems();
    }

    function saveAddGuestToBookingItem() {
      GuestService.checkInGuestToBooking(vm.guest, notes).then(function (data) {
        vm.onSavedItem({ item: data.response });
      });
    }

    function cancel() {
      vm.onCanceledItem();
    }
  }
})();
